// Headline fill: the rose part of a headline (an <em> marked by the editors, or else the first part of a two-part
// headline) starts in the headline colour and fills with rose from left to right when it scrolls into view, line
// by line (the CSS sweeps a gradient behind the text). The quote block lights its words up instead (word-fill.js).
import { onceVisible } from './motion.js'

// the same parts base/_article.scss colours rose
const ROSE_PARTS = '.yn-article__heading em, .heading:not(:has(em)) .heading__first:has(+ .heading__second)'

export function initHeadingFill() {
	const parts = [...document.querySelectorAll(ROSE_PARTS)].filter((part) => !part.closest('[data-word-fill]'))
	onceVisible(parts, (part) => part.classList.add('is-filled'))
}
